
import {Component, Vue} from 'vue-property-decorator';
import {mixins} from "vue-class-component";
import {abstractField} from "vue-form-generator";
import CompetitionRegistrationActionCrudComponent
  from "@/components/competition/registration/CompetitionRegistrationActionCrudComponent.vue";

@Component({
  components: {CompetitionRegistrationActionCrudComponent}
})
export default class CompetitionRegistrationActionCrudField extends mixins(Vue, abstractField) {
  get disabled() {
    // @ts-ignore
    return this.schema.disabled || false
  }

  get federationRef() {
    // @ts-ignore
    return this.schema.federationRef
  }
}
